import React, { useState } from 'react'
import { Accordion, Card, Button } from 'react-bootstrap'

const Index = () => {

    const [activeTab, setActiveTab] = useState("0")

    return(
        <div className="tab-section-container">
            <div className="inner-tab-section-container">
                <p className="introduction-text">
                    Kundeoversikten hjelper deg med å samle alle kundene bedriften din har på ett sted, og gir muligheten til å loggføre både bedriftskunder og personkunder hver for seg. På denne måten kan du få et bedre overblikk over kundehistorikk, og gjøre denne tilgjengelig for andre partnere eller kollegaer.
                    <br/><br/>
                    Dersom du jobber primært mot bedrifter (B2B) kan du legge til en kunde bare ved å oppgi organisasjonsnummeret til bedriften og trykke enter, og dataen vil bli hentet automatisk.
                </p>
                <div className="accordion-container">
                <Accordion className="company-accordion" defaultActiveKey="0" activeKey={activeTab}>
				<Card className="single-card top">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="0" onClick={() => setActiveTab("0")}>
							<button className={`collapse-button ${activeTab === "0" ? "active":""}`}>{activeTab === "0" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Legg til en ny kunde
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="0">
						<Card.Body className="card-body">
                            <p className="description-text">Når du skal legge til en kunde kan du velge mellom å legge til en personkunde eller en bedriftskunde, og dette er hvordan du gjør det:</p>
							<ol className="description-list">
								<li>Gå til <span className="bold">"Kunder"</span> fra menyen til venstre.</li>
								<li>Trykk på <span className="bold">"Ny kunde"</span>-knappen oppe til høyre hjørne.</li>
								<li>Velg kundetype og fyll inn kundeinformasjonen.</li>
								<li>Trykk på <span className="bold">"Legg til"</span>-knappen nederst i popup.</li>
							</ol>
							<p className="description-text">Vennligst merk deg at dersom du skal legge inn en bedriftskunde kan du velge å enten hente ut informasjonen automatisk eller legge den til manuelt. Du kan gjøre det automatisk ved å skrive inn organisasjonsnummer og trykke <span className="bold">"Enter"</span>-knappen.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card top">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="1" onClick={() => setActiveTab("1")}>
                            <button className={`collapse-button ${activeTab === "1" ? "active":""}`}>{activeTab === "1" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Endre en kunde
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="1">
						<Card.Body className="card-body">
                            <p className="description-text">For å endre på en eksisterende kunde kan du gjøre følgende:</p>
							<ol className="description-list">
								<li>Gå til <span className="bold">"Kunder"</span> fra menyen til venstre.</li>
								<li>Trykk på penn-ikonet til høyre for navnet på kunden du ønsker å endre.</li>
								<li>Gjør de endringene du behøver og trykk på <span className="bold">"Oppdater"</span>-knappen.</li>
							</ol>
							<p className="description-text">Du kan også endre på kunden ved å først velge kunden i kundelisten, og deretter trykke på <span className="bold">"Rediger kunde"</span>-knappen inne på kunden sin respektive side.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="2" onClick={() => setActiveTab("2")}>
                            <button className={`collapse-button ${activeTab === "2" ? "active":""}`}>{activeTab === "2" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Slett en kunde
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="2">
						<Card.Body className="card-body">
                            <p className="description-text">Dersom du ønsker å slette en kunde kan du gjøre dette slik:</p>
							<ol className="description-list">
								<li>Gå til <span className="bold">"Kunder"</span> fra menyen til venstre.</li>
								<li>Trykk på søppeldunk-ikonet til høyre for navnet på kunden du ønsker å slette.</li>
								<li>Trykk på <span className="bold">"Ja, slett kunden"</span>-knappen i popup.</li>
							</ol>
							<p className="description-text">Du kan også slette kunden ved å først velge kunden i kundelisten, og deretter trykke på <span className="bold">"Fjern som kunde"</span>-knappen inne på kunden sin respektive side.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
				    <Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="3" onClick={() => setActiveTab("3")}>
                            <button className={`collapse-button ${activeTab === "3" ? "active":""}`}>{activeTab === "3" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Se kundeinformasjon
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="3">
						<Card.Body className="card-body">
                            <p className="description-text">For å se all kundeinformasjon om en av dine kunder kan du gjøre dette:</p>
							<ol className="description-list">
								<li>Gå til <span className="bold">"Kunder"</span> fra menyen til venstre.</li>
								<li>Velg mellom <span className="bold">Bedriftskunder</span> eller <span className="bold">Personkunder</span> i fanene under søkefeltet.</li>
								<li>Trykk så på kunden du ønsker å se mer informasjon om.</li>
							</ol>
							<p className="description-text">Du kan se ulik kundeinformasjon ved å benytte deg av fanene på kundesiden.</p>
							<h5 className="description-subtitle">Bedriftsinformasjon</h5>
							<p className="description-text">Bedriftsinformasjon vises kun for bedriftskunder under <span className="bold">"Detaljer"</span>-fanen, og lar deg få innsikt i generell bedriftsinformasjon som bransje, stiftelsesdato, antall ansatte og mer. Denne informasjonen vises kun hvis du har hentet informasjonen automatisk.</p>
							<h5 className="description-subtitle">Roller</h5>
							<p className="description-text">Roller vises kun for bedriftskunder og du finner de under <span className="bold">Roller</span>-fanen, som viser deg en detaljert liste over alle personer med roller i bedriften og hvilken stilling de har.</p>
							<h5 className="description-subtitle">Aksjonærer</h5>
							<p className="description-text">Aksjonærlisten vises kun på bedriftskunder og ikke personkunder, og du finner den under <span className="bold">"Aksjonærer"</span>-fanen. Det gir et innblikk i hvem aksjonærene i selskapet er og hvor store andeler de eier.</p>
							<h5 className="description-subtitle">Salg</h5>
							<p className="description-text">Salg vises for både personkunder og bedriftskunder og du finner denne oversikten under <span className="bold">"Salg"</span>-fanen. Her kan du se på, legge til, endre og slette salg på den spesifikke bedriften.</p>
							<h5 className="description-subtitle">Notater</h5>
							<p className="description-text">Alle notater som er gjort på bedriften av enten deg eller en samarbeidspartner havner under <span className="bold">Aktivitet</span>-seksjonen på høyre side av kundevisningen, og er tilgjengelig for både bedriftskunder og personkunder.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="4" onClick={() => setActiveTab("4")}>
                            <button className={`collapse-button ${activeTab === "4" ? "active":""}`}>{activeTab === "4" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Legg til et salg
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="4">
						<Card.Body className="card-body">
                            <p className="description-text">For å registrere et salg på en kunde, gjør slik:</p>
							<ol className="description-list">
								<li>Gå til salgsoversikten under <span className="bold">"Salg"</span>-fanen på kundesiden.</li>
								<li>Trykk på <span className="bold">Nytt salg</span>-knappen.</li>
								<li>Legg så inn korrekte detaljer av salget.</li>
								<li>Trykk på <span className="bold">Legg til</span>-knappen nederst i popup.</li>
							</ol>
							<p className="description-text">Salget vil da bli registrert på kunden, og salgshistorikken vil bli oppdatert.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
                <Card className="single-card last">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="5" onClick={() => setActiveTab("5")}>
                            <button className={`collapse-button ${activeTab === "5" ? "active":""}`}>{activeTab === "5" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Legg til notat
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="5">
						<Card.Body className="card-body">
                            <p className="description-text">Dersom du ønsker å legge til et notat på en kunde, gjør følgende:</p>
							<ol className="description-list">
								<li>Gå inn på kunden du ønsker å legge til et notat på.</li>
								<li>Trykk på tekstfeltet nederst under <span className="bold">Aktivitet</span>-seksjonen på høyre side.</li>
								<li>Skriv inn ønsket notat.</li>
								<li>Trykk på <span className="bold">Enter</span>-knappen.</li>
							</ol>
							<p className="description-text">Listen over notater vil da bli oppdatert og vise ditt nye notat, inkludert tidligere notater skrevet av enten deg eller andre med tilgang til arbeidsmiljøet ditt, dersom det finnes.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
			</Accordion>
                </div>
            </div>
        </div>
    )
}

export default Index